import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ProjectMemberRoleType } from '@projectMembers/models/projectRole';
import useProjectMembersSystem from '../system/useProjectMembersSystem';
import { QueryKeys } from './keysAndFilters';

export type UseInviteMemberMutationParams = {
	projectID: number;
	onSuccess?: () => void,
	onError?: ( error: unknown ) => void
};

const useInviteMemberMutation = ( {
	projectID, onSuccess: onMutationSuccess, onError: onMutationError
}: UseInviteMemberMutationParams ) => {
	const system = useProjectMembersSystem();
	const queryClient = useQueryClient();

	const onSuccess = useCallback( () => {
		queryClient.invalidateQueries( {
			queryKey: QueryKeys.forProjectMembers( { projectID } ),
			refetchType: 'active'
		} );

		queryClient.invalidateQueries( {
			queryKey: QueryKeys.forProjectInvitations( { projectID } ),
			refetchType: 'active'
		} );

		onMutationSuccess?.();
	}, [ onMutationSuccess, projectID, queryClient ] );

	return useMutation(
		( { emails, role }: { emails: string[], role: ProjectMemberRoleType } ) => (
			system.inviteMembers( { projectID, emails, role } )
		),
		{ onSuccess, onError: onMutationError }
	);
}

export default useInviteMemberMutation;
